import AppSwitch from "../../design-system/components/AppSwitch";
import "./availabilityLegacy.css";

export default function AvailabilitySwitchSection({
  title,
  description,
  checked,
  onChange,
  disabled = false,
  switchLabel,
  className = "",
  ...props
}) {
  const classes = ["availability-switch-section", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <div className="availability-switch-section__copy">
        <strong>{title}</strong>
        {description ? <span>{description}</span> : null}
      </div>
      <AppSwitch
        label={switchLabel}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </div>
  );
}
